
import { defineComponent } from "vue";
import SamplingPointStationComponent from "@/components/samplingPointStation/SamplingPointStation.component.vue";
import SamplingPointStationFormComponent from "@/components/samplingPointStation/SamplingPointStationForm.component.vue";

import { SamplingPointStation } from "@/types/samplingPointStation.type";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import { getSamplingPointStation } from "@/service/samplingpointstation.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { ElMessage } from "element-plus";

export default defineComponent({
  components: {
    SamplingPointStationComponent,
    PageButtonsComponent,
    SamplingPointStationFormComponent,
  },
  setup() {
    const store = useStore<RootState>();
    return { store };
  },
  data() {
    return {
      samplingPointStations: [] as SamplingPointStation[],
      showEntityForm: false,
    };
  },
  computed: {
    selectSamplingpoint(): SamplingPoint {
      return this.store.state.samplingpoint.samplingPoint;
    },
  },
  async mounted() {
    this.samplingPointStations = await getSamplingPointStation(
      this.$route.params.samplingpointid as string
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    openEntityFormDialog() {
      this.showEntityForm = true;
    },

    async saveEntity() {
      await (this.$refs["entityForm"] as InstanceType<typeof SamplingPointStationFormComponent>)
        .doSave()
        .then(async () => {
          this.showEntityForm = false;
          this.samplingPointStations = await getSamplingPointStation(
            this.$route.params.samplingpointid as string
          );
          ElMessage.success(this.$t("success.action"));
        });
    },
  },
});
